import Swal from "sweetalert2"

// Admin global behaviors: utils (ex-functions.js) + turbo:load block.

// ── funções utilitárias (ex-functions.js) ──────────────────────────────
// As funções de seleção via modal (preparaModalSelecaoBase / preparaModalSelecao)
// foram migradas para o Stimulus modal_selection_controller.

/**
 * Funcoes de calculo e marcacao dos Pagamentos
 */
function executaPgtoMarcacao(thiz, pagamentoTotal) {
  let totalizador = 0;
  const attrId = thiz.id;
  const attrPg = document.querySelector('#' + attrId);
  const attrTd = attrPg.value;
  const pg = document.querySelector('#pagamento-' + attrTd);
  if (attrPg.checked) {
    executaPgtoCalculo('somar', totalizador, pagamentoTotal, pg);
    pg.style.fontWeight = 'bold';
  } else {
    executaPgtoCalculo('subtrair', totalizador, pagamentoTotal, pg);
    pg.removeAttribute('style');
  }
}

function executaPgtoCalculo(acao, totalizador, pagamentoTotal, pg) {
  let s = pagamentoTotal.textContent;
  let p = pg.dataset.valor;
  totalizador = acao === 'somar' ? (parseFloat(s) + parseFloat(p)) : (parseFloat(s) - parseFloat(p));
  pagamentoTotal.textContent = totalizador.toFixed(2);
  if (totalizador < 0) {
    pagamentoTotal.textContent = 0;
  }
}

/**
 * UTILS
 * @param evt
 * @param url
 */
window.abrirUrl = function (evt, url) {
  if (evt.target.toString() === '[object HTMLTableCellElement]') {
    evt.stopPropagation();
    if (url) {
      window.location.href = url
    }
  }
};

window.notify = function (tipo, mensagem) {
  Swal.fire({ text: mensagem, icon: tipo })
}

// ── comportamentos globais do admin (ex-application.js, bloco turbo:load) ─
document.addEventListener("turbo:load", function () {
  /**
   * ToggleMega Menu
   */
  document.querySelectorAll('.mega-menu').forEach(function (el) {
    el.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  document.querySelectorAll('.botao-menu').forEach(function (botao) {
    botao.addEventListener('click', function (e) {
      e.stopPropagation();
      const target = document.querySelector(botao.dataset.target);
      const visivel = target && getComputedStyle(target).display !== 'none';
      document.querySelectorAll('.botao-menu').forEach(function (n) { n.classList.remove('is-active'); });
      if (!visivel) {
        document.querySelectorAll('.mega-menu').forEach(function (m) { m.style.display = 'none'; });
        if (target) target.style.display = '';
        botao.classList.add('is-active');
      } else if (target) {
        target.style.display = 'none';
      }
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('.mega-menu').forEach(function (m) { m.style.display = 'none'; });
    document.querySelectorAll('.botao-menu').forEach(function (n) { n.classList.remove('is-active'); });
  });


  /**
   * UTILS
   * Janela de notificacao
   */
  document.querySelectorAll('.fechar-notificacao').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      if (el.parentElement) el.parentElement.style.display = 'none';
    });
  });

  /**
   * UTILS
   * Filtra as permissoes do Admin na Instituicao selecionada
   */
  document.querySelectorAll('[name="permissao[instituicao_id]"]').forEach(function (el) {
    el.addEventListener('change', function () {
      const adminId = document.querySelector('#permissao_admin_id').value;
      window.location.href = window.location.pathname + "?" + new URLSearchParams({ admin_id: adminId, instituicao_id: el.value }).toString();
    });
  });

  document.querySelectorAll('[name="permissao[estabelecimento_id]"]').forEach(function (el) {
    el.addEventListener('change', function () {
      const adminId = document.querySelector('#permissao_admin_id').value;
      window.location.href = window.location.pathname + "?" + new URLSearchParams({ admin_id: adminId, estabelecimento_id: el.value }).toString();
    });
  });

  /**
   * UTILS
   * Consulta de CEP ao sair do campo (blur)
   */
  const enderecoCampos = document.querySelectorAll('.endereco');
  document.querySelectorAll('.cep').forEach(function (cepEl) {
    cepEl.addEventListener('blur', function (e) {
      e.preventDefault();
      const cep = cepEl.value.replace('-', '');
      if (cep === '') return;
      enderecoCampos.forEach(function (c) { c.disabled = true; });
      const validaCep = /^[0-9]{8}$/;
      if (!validaCep.test(cep)) {
        enderecoCampos.forEach(function (c) { c.disabled = false; });
        return;
      }
      // fetch nativo (sem o header X-CSRF-Token, que dispara preflight CORS recusado
      // pelo viacep). GET simples — CSP connect_src libera viacep.
      fetch("https://viacep.com.br/ws/" + cep + "/json/")
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (!("erro" in data)) {
            const ruaEl = document.querySelector(cepEl.dataset.rua);
            if (ruaEl) ruaEl.value = data.logradouro;
            const compEl = document.querySelector(cepEl.dataset.complemento);
            if (compEl) compEl.value = data.complemento;
            const bairroEl = document.querySelector(cepEl.dataset.bairro);
            if (bairroEl) bairroEl.value = data.bairro;
            // Estado (Tom Select): acha a option pelo texto "UF - Nome" e seleciona via API
            // (setValue atualiza o widget E dispara change -> cascata popula as cidades).
            const ufEl = document.querySelector(cepEl.dataset.uf);
            if (ufEl) {
              const estadoOpt = Array.from(ufEl.options).find(function (o) { return o.textContent.includes(data.uf + ' - '); });
              if (estadoOpt) {
                if (ufEl.tomselect) { ufEl.tomselect.setValue(estadoOpt.value); }
                else { ufEl.value = estadoOpt.value; ufEl.dispatchEvent(new Event('change')); }
              }
            }
            // Cidade: apos a cascata popular as opcoes
            setTimeout(function () {
              const cidadeEl = document.querySelector(cepEl.dataset.cidade);
              if (cidadeEl) {
                const cidadeOpt = Array.from(cidadeEl.options).find(function (o) { return o.textContent.includes(data.localidade); });
                if (cidadeOpt) {
                  if (cidadeEl.tomselect) { cidadeEl.tomselect.setValue(cidadeOpt.value); }
                  else { cidadeEl.value = cidadeOpt.value; }
                }
              }
            }, 500);
          }
        })
        .catch(function () { /* erro de rede ignorado */ })
        .finally(function () {
          enderecoCampos.forEach(function (c) { c.disabled = false; });
        });
    });
  });

  let tkn = document.getElementById('app').getAttribute('data-hash');

  /**
   * FILTROS
   * Filtra Cidades por Estado. Filtra Modelos por Marca
   */
  // Repopula um <select> filho da cascata com os itens [{id, nome}].
  // Se o select for um Tom Select, usa a API nativa (clearOptions/addOption/
  // refreshOptions) — forma idiomatica. Senao (selects sem widget, ex.: filtros
  // de index), manipula as <option>s direto. Sem MutationObserver.
  function preencheCascata(seletor, itens, rotuloVazio) {
    document.querySelectorAll('select' + seletor).forEach(function (sel) {
      const ts = sel.tomselect;
      if (ts) {
        ts.clear(true);
        ts.clearOptions(function () { return false; }); // remove TODAS (o default mantem as selecionadas)
        ts.addOption({ value: '', text: rotuloVazio });
        itens.forEach(function (i) { ts.addOption({ value: String(i.id), text: i.nome }); });
        ts.refreshOptions(false);
        ts.enable();
      } else {
        sel.innerHTML = '<option value="">' + rotuloVazio + '</option>';
        itens.forEach(function (i) {
          const o = document.createElement('option');
          o.value = i.id;
          o.textContent = i.nome;
          sel.appendChild(o);
        });
        sel.disabled = false;
      }
    });
  }

  document.querySelectorAll('.lista-estados').forEach(function (el) {
    el.addEventListener('change', function (e) {
      const destino = e.target.dataset.destino || '.lista-cidades';
      fetch("/cidades/filtrar?hash=" + tkn + "&item=" + e.target.value)
        .then(function (r) { return r.json(); })
        .then(function (data) { preencheCascata(destino, data, 'Selecione a Cidade'); })
        .catch(function () {});
    });
  });

  // Seleção de Estabelecimentos/Motoristas/Associados/Instituições/Admins via modal:
  // migrado para o Stimulus modal_selection_controller (data-controller="modal-selection").

  document.querySelectorAll('.modal-close').forEach(function (el) {
    el.addEventListener('click', function () {
      document.querySelectorAll('.modal').forEach(function (m) { m.classList.remove('is-active'); });
    });
  });

  /**
   * Admin: Marca Todos
   */
  const marcarTodos = document.querySelector('#marcar_todos');
  if (marcarTodos) {
    marcarTodos.addEventListener('click', function () {
      const c = this.checked;
      document.querySelectorAll('.bulk').forEach(function (el) {
        el.style.fontWeight = 'bold';
        el.checked = !!c;
      });
    });
  }

  /**
   * Dropdown
   */
  document.querySelectorAll('.dropdown').forEach(function (drop) {
    drop.addEventListener('click', function (event) {
      event.stopPropagation();
      document.querySelectorAll('.dropdown').forEach(function (d) { if (d !== drop) d.classList.remove('is-active'); });
      drop.classList.toggle('is-active');
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('.dropdown').forEach(function (d) { d.classList.remove('is-active'); });
  });

  /**
   * Remove shadow when scroll to bottom!
   */
  if (document.documentElement.scrollHeight > window.innerHeight) {
    document.querySelectorAll('.actions').forEach(function (a) { a.classList.add('shadow'); });
  } else {
    document.querySelectorAll('.actions').forEach(function (a) { a.classList.remove('shadow'); });
  }
  window.onscroll = function () {
    if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight) {
      document.querySelectorAll('.actions').forEach(function (a) { a.classList.remove('shadow'); });
    } else {
      document.querySelectorAll('.actions').forEach(function (a) { a.classList.add('shadow'); });
    }
  };

  /**
   * Venda Estabelecimento
   */
  const btnVenda = document.querySelector('#btn-venda');
  if (btnVenda) {
    btnVenda.addEventListener('click', function (e) {
      e.preventDefault();
      const v = function (sel) { const el = document.querySelector(sel); return el ? el.value : ''; };
      const valor = v('#c_valor'), cartao = v('#c_numero_cartao'), senha = v('#c_senha');
      const km = document.querySelector('#c_km');
      const litros = v('#c_litros'), precoLitro = v('#c_preco_litro');
      let erros = 0;
      const vendaCombustivel = !!(km && km.offsetParent !== null);
      if ((!valor || !cartao || !senha) || (vendaCombustivel && (!valor || !cartao || !senha || !km.value || !litros || !precoLitro))) {
        erros = 1;
      }
      const tipoVenda = vendaCombustivel ? 'COMBUSTIVEL' : '';
      if (erros === 1) {
        window.notify('error', 'Por favor, preencha todos os campos da venda.');
      } else {
        Swal.fire({
          title: "Confirmação",
          text: "Confirma venda " + tipoVenda + " de R$ " + valor + " no cartão final " + cartao.substr(cartao.length - 4) + "?",
          showCancelButton: true,
          confirmButtonColor: "#23d160",
          confirmButtonText: "Efetuar venda!",
          cancelButtonText: "Cancelar"
        }).then((result) => {
          if (result.isConfirmed) {
            document.querySelector('#form-venda').requestSubmit();
          }
        });
      }
    });
  }

  /**
   * Venda QRCode Estabelecimento
   */
  const btnVendaQrcode = document.querySelector('#btn-venda-qrcode');
  if (btnVendaQrcode) {
    btnVendaQrcode.addEventListener('click', function (e) {
      e.preventDefault();
      const valorEl = document.querySelector('#c_valor');
      const valor = valorEl ? valorEl.value : '';
      if (!valor) {
        window.notify('error', 'Por favor, preencha todos os campos da venda.');
      } else {
        Swal.fire({
          title: "Confirmação",
          text: "Confirma venda de R$ " + valor + "?",
          showCancelButton: true,
          confirmButtonColor: "#23d160",
          confirmButtonText: "Efetuar venda!",
          cancelButtonText: "Cancelar"
        }).then((result) => {
          if (result.isConfirmed) {
            document.querySelector('#form-venda-qrcode').requestSubmit();
          }
        });
      }
    });
  }

  /**
   * Menu Hamburguer
   */
  let $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
  if ($navbarBurgers.length > 0) {
    $navbarBurgers.forEach(function ($el) {
      $el.addEventListener('click', function () {
        let target = $el.dataset.target;
        let $target = document.getElementById(target);
        $el.classList.toggle('menu-mobile');
        $target.classList.toggle('menu-mobile');
      });
    });
  }

  document.querySelectorAll('.tabs').forEach(function (tabParent) {
    const tabs = Array.from(tabParent.querySelectorAll('li'));
    const contentsParent = (tabParent.nextElementSibling && tabParent.nextElementSibling.classList.contains('tabs-content')) ? tabParent.nextElementSibling : null;
    const contents = contentsParent ? Array.from(contentsParent.querySelectorAll('.tab-content')) : [];
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tabs[index].classList.add('is-active');
        contents.forEach(function (c) { c.classList.remove('is-active'); });
        if (contents[index]) contents[index].classList.add('is-active');
      });
    });
  });

  /**
   * Calculo dos pagamentos
   */
  const pagamentoTotal = document.querySelector('#pagamento_total');
  // Marcar todos
  const marcarTodosPg = document.querySelector('#marcar_todos_pg');
  if (marcarTodosPg) {
    marcarTodosPg.addEventListener('click', function () {
      const c = this.checked;
      pagamentoTotal.textContent = 0;
      document.querySelectorAll('.bulk').forEach(function (el) {
        el.checked = !!c;
        executaPgtoMarcacao(el, pagamentoTotal);
      });
      if (!this.checked) {
        pagamentoTotal.textContent = 0;
      }
    });
  }

  // Destacar
  document.querySelectorAll('[id^="pagamento_"]').forEach(function (el) {
    el.addEventListener('click', function () {
      executaPgtoMarcacao(el, pagamentoTotal);
    });
  });
});
